// Shared by the editor's Flags tab and the assistant's flag tools

export const DEFAULT_BUILTIN_FLAGS: AgentEscalationFlag[] = [
  { id: "high_risk", type: "builtin", label: "High Risk", icon: "alert-triangle", detection_prompt: "Determine if this message indicates a high-risk situation where the user may be in danger, discussing self-harm, or facing an emergency that requires immediate attention.", enabled: true },
  { id: "low_confidence", type: "builtin", label: "Low Confidence", icon: "help-circle", detection_prompt: "Determine if the AI assistant's response shows low confidence, uncertainty, or may be providing inaccurate information that a human should verify.", enabled: true },
  { id: "asked_human", type: "builtin", label: "Asked for Human", icon: "user", detection_prompt: "Determine if the user is explicitly asking to speak with a human agent, requesting to be transferred, or expressing dissatisfaction with the automated response.", enabled: true },
]

export const FLAG_ICONS = [
  "alert-triangle", "help-circle", "user", "flag", "zap", "bug",
  "message-circle", "brain-cog", "settings", "cog", "workflow", "wrench",
]

export const MAX_FLAGS = 6

// Fired when something other than the settings dialog changes app.agent's flags or forms
export const AGENT_SETTINGS_CHANGED_EVENT = "agent:settings-changed"

// The flags the editor shows: the built-ins until any are set
export const flagsOf = (agent: Agent): AgentEscalationFlag[] =>
  agent?.escalationFlags?.length ? agent.escalationFlags : DEFAULT_BUILTIN_FLAGS
